import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useNavigationBar } from "../../../context/NavigationContext";
import { TopicType } from "../../../models/SKArtifact";
import { CreateChannelContext } from "../../../context/CreateChannelContext";
import { updateChannel } from "../../../api/channels/channelServices";
import LoadingPopup from "./LoadingPopup";
import { capitalizeFirstLetter } from "../../../utils/stringFunctions";
import { Timestamp } from "firebase/firestore";
import { TopicTypeString } from "../../../models/SKArtifact";
import { EditChannelContext } from "../../../context/EditChannelContext";

interface TopicProps {
  isEdit?: boolean;
}
export default function ChannelTopic({ isEdit = false }: TopicProps) {
  const topicData = [
    {
      id: 1,
      icon: "/icons/Entertainment.png",
      topic: TopicType.entertainment,
    },
    {
      id: 2,
      icon: "/icons/FoodandDrink.png",
      topic: TopicType.food,
    },
    {
      id: 3,
      icon: "/icons/Travel.png",
      topic: TopicType.travel,
    },
    {
      id: 4,
      icon: "/icons/Music.png",
      topic: TopicType.music,
    },
    {
      id: 5,
      icon: "/icons/Fashion.png",
      topic: TopicType.fashion,
    },
    {
      id: 6,
      icon: "/icons/HealthandFitness.png",
      topic: TopicType.health,
    },
    {
      id: 7,
      icon: "/icons/Technology.png",
      topic: TopicType.technology,
    },
    {
      id: 8,
      icon: "/icons/Sports.png",
      topic: TopicType.sports,
    },
    {
      id: 9,
      icon: "/icons/Culture.png",
      topic: TopicType.culture,
    },
    {
      id: 10,
      icon: "/icons/Shopping.png",
      topic: TopicType.shopping,
    },
    {
      id: 11,
      icon: "/icons/KidsandFamily.png",
      topic: TopicType.kids,
    },
    {
      id: 12,
      icon: "/icons/Business.png",
      topic: TopicType.business,
    },
    {
      id: 13,
      icon: "/icons/Environment.png",
      topic: TopicType.environment,
    },
    {
      id: 14,
      icon: "/icons/Education.png",
      topic: TopicType.education,
    },
    {
      id: 15,
      icon: "/icons/games.png",
      topic: TopicType.games,
    },
    {
      id: 16,
      icon: "/icons/Books.png",
      topic: TopicType.books,
    },
    {
      id: 17,
      icon: "/icons/Design.png",
      topic: TopicType.design,
    },
  ];

  // const { channelData, updateChannelData, updateDataOnServer, loading } = useContext(CreateChannelContext);

  const editChannelContext = useContext(EditChannelContext);
  const createChannelContext = useContext(CreateChannelContext);

  // Determine which function to use based on the available context

  const channelData = isEdit ? editChannelContext?.channelEditData : createChannelContext?.channelData;
  const loading = isEdit ? editChannelContext?.loading : createChannelContext?.loading;
  const updateChannelData = isEdit ? editChannelContext?.updateChannelEditData : createChannelContext?.updateChannelData;
  const updateDataOnServer = isEdit ? editChannelContext?.updateEditDataOnServer : createChannelContext?.updateDataOnServer;

  // const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { setNavProps } = useNavigationBar();
  const [channelState, setChannelState] = useState({ key: "", value: "" });

  useEffect(() => {
    setNavProps({
      backArrow: false,
      subtitle: "Channel",
      title: "Topic",
      buttonTitle: "Done",
      filterOption: true,
      enableLink: channelData.topic ? true : false,
      //onBack: () => alert("Back Clicked"),
      //onFilter: () => {},
      onNext: () => {
        updateDataOnServer && updateDataOnServer();
        navigate(-1);
      },
      onClose: () => {
        navigate(-1);
      },
    });
  }, [setNavProps, navigate, updateDataOnServer]);

  // const updateChannels = async () => {
  //   setIsLoading(true);
  //   await updateChannel(channelData.id!, channelData);
  //   setIsLoading(false);
  //   navigate(-1);
  // };

  // useEffect(() => {
  //   if ((channelData.topic?.length as number) != 0) {
  //     setSelectedItem(topicData[topicData.findIndex(item => item.topic === channelData.topic)]?.topic);
  //     setEnabled(true);
  //   }
  // });

  const handleClick = (data: TopicType) => (event: React.MouseEvent<HTMLElement>) => {
    setNavProps(prev => ({ ...prev, enableLink: true }));
    updateChannelData({
      ...channelData,
      topic: data,
    });
  };

  return (
    <div className="channel-page-context">
      <LoadingPopup isLoading={loading} />
      <div className="flex flex-col">
        <div className="mb-5 flex flex-col space-y-[10px] w-full">
          <div className="mb-5 flex flex-col space-y-[10px] w-full">
            <label className="title_inner_page">Choose the primary topic of your channel.</label>
            <label className="notes_inner_page">Choose the topic that represents the primary focus of most of your content.</label>
            <div className="mb-5 flex flex-col space-y-[2px] w-full">
              <ul className="space-y-2">
                {topicData.map(item => (
                  <li onClick={handleClick(item.topic)} key={item.id} className="flex items-center topic-item">
                    <img
                      src={channelData.topic === item.topic ? "/svg/circlechecked.svg" : "/svg/circle.svg"}
                      alt={TopicTypeString[item.topic]}
                      className="object-cover w-6 h-6"
                    />
                    <div className="topic-image-box-updated">
                      <img className="object-contain w-[35px] h-[35px]" src={item.icon} alt={TopicTypeString[item.topic]} />
                    </div>
                    <div className="flex-1">
                      <p className="items-center justify-center capitalize radio-button-label">{item.topic ? TopicTypeString[item.topic] : ""}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
